export const noplProductFilter = (customerId?: any) => ({
  product: {
    or: [
      // product not nopl, or product IS nopl and customer in product
      { not: { matches: { legacy_stock_code: { like: "nopl" } } } },
      {
        exists: {
          path: ["product_master", { name: "customers", filter: { matches: { id: customerId } } }],
        },
      },
    ],
  },
  productMasterNegative: {
    or: [
      { exists: { path: [{ name: "customers", filter: { matches: { id: customerId } } }] } },
      {
        not: {
          exists: {
            path: [
              { name: "products", filter: { matches: { legacy_stock_code: { like: "nopl" } } } },
            ],
          },
        },
      },
    ],
  },
})
